<template>
  <div class="system">
    <div class="sys-header">
      <h2>常用系统</h2>
      <span @click="edito" v-if="!editoStatus">编辑</span>
    </div>
    <div class="sys-container" v-trace-click="'n.3386.6047.0'">
      <div class="tip" v-show="editoStatus">
        最多支持16个常用系统添加和展示；鼠标拖动“系统名称”可进行排序；确认当前效果，记得
        <span @click="edito">保存</span>
      </div>

      <div class="sys-list-box" :style="{overflow: editoStatus?'visible':''}">
        <div
          v-if="!editoStatus"
          class="sys-list"
          ref="list"
          :style="{flexWrap: editoStatus?'wrap':'',overflow: editoStatus?'visible':'','--margin': margin,marginLeft:marginLeft}"
        >
          <div
            class="sys-item"
            v-for="(item,index) in mySystem"
            :key="index"
            target="_blank"
            :data-index="item.url"
            @click="toUrl(item)"
          >
            <i class="el-icon-error" @click="sysDel(index)" v-show="editoStatus"></i>
            <el-badge :is-dot="item.show_update==1" class="icon-round">
              <div class :style="bgcolor[index%4]">{{item.title.slice(0,2)}}</div>
            </el-badge>
            <span class="sys-name">{{item.title}}</span>
          </div>
          <div
            slot="footer"
            class="sys-item l-item"
            @click="dialogVisbility=true"
            :key="'gzb'"
            v-if="!editoStatus&&mySystem.length<16"
          >
            <div class="hollow-round">
              <i class="el-icon-plus"></i>
            </div>
            <span class="sys-add">添加常用系统</span>
          </div>
        </div>

        <draggable v-else v-model="mySystem" group="people">
          <transition-group
            class="sys-list"
            name="list"
            :style="{flexWrap: editoStatus?'wrap':'',overflow: editoStatus?'visible':'','--margin': margin,marginLeft:marginLeft}"
          >
            <div class="sys-item" v-for="(item,index) in mySystem" :key="item.key">
              <i class="el-icon-error" @click="sysDel(index)" v-show="editoStatus"></i>
              <div class="icon-round" :style="bgcolor[index%4]">{{item.title.slice(0,2)}}</div>
              <span class="sys-name">{{item.title}}</span>
            </div>
          </transition-group>
        </draggable>
      </div>
    </div>
    <AddSysytem :dialogVisbility.sync="dialogVisbility" />
  </div>
</template>

<script>
import AddSysytem from "./add-sysytem";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
export default {
  name: "commonlySystem",
  components: {
    AddSysytem,
    draggable
  },
  data() {
    return {
      editoStatus: false,
      dialogVisbility: false,
      addIcon: false,
      bgcolor: [
        {
          background: "rgba(24, 144, 255, 0.1)",
          color: "rgba(24, 144, 255, 1)"
        },
        {
          background: "rgba(103, 194, 58, 0.1)",
          color: "rgba(103, 194, 58, 1)"
        },
        {
          background: "rgba(255, 140, 58, 0.1)",
          color: "rgba(255, 140, 58, 1)"
        },
        {
          background: "rgba(78, 100, 255, 0.1)",
          color: "rgba(78, 100, 255, 1)"
        }
      ],
      margin: "20px",
      marginLeft: 0
    };
  },
  computed: {
    mySystem: {
      get() {
        return this.$store.getters.mySystem;
      },
      set(value) {
        value.forEach((item, index) => {
          item.sort = index + 1;
        });
        this.$store.commit("SET_SYSTEM", value);
      }
    }
  },
  watch: {},
  methods: {
    toUrl(system) {
      _api.product.postSaveFavoriteVisitLog({
        favorite_id: system.id
      });
      if (system.show_update) {
        let routeUrl = this.$router.resolve({
          path: "/link",
          query: {
            url: system.url,
            key: system.key,
            date: system.c_t,
            name: system.title,
            type: 2
          }
        });
        window.open(routeUrl.href, "_blank");
      } else {
        window.open(system.url);
      }
    },
    edito() {
      this.editoStatus = !this.editoStatus;
      if (!this.editoStatus) {
        this.margin = "20px";
        let save_data = this.mySystem.map((item, index) => {
          let i = {
            key: item.key,
            sort: index + 1
          };
          return i;
        });
        _api.home.saveSystem({ save_data }).then(res => {
          this.$store.dispatch("getSystem");
        });
      } else {
        this.margin = "0";
        this.marginLeft = 0;
      }
    },
    sysDel(num) {
      event.stopPropagation();
      event.preventDefault();
      this.mySystem.splice(num, 1);
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.system {
  margin-bottom: 30px;
  h2 {
    line-height: 16px;
    color: rgba(48, 49, 51, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
  }
}
.sys-header {
  display: flex;
  align-items: center;
  span {
    margin-left: 10px;
    color: #999;
    cursor: pointer;
    line-height: 24px;
  }
}
.sys-container {
  position: relative;
  .tip {
    margin-top: 12px;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    background-color: rgba(254, 252, 235, 1);
    color: #f96a0e;
    padding-left: 20px;
    font-size: 12px;
    span {
      color: #1890ff;
      cursor: pointer;
    }
  }
}
.sys-list-box {
  width: 1200px;
  overflow: hidden;
}
.sys-list {
  display: flex;
  flex-wrap: wrap;
  transition: all 1s 0s;
  .sys-item {
    flex-shrink: 0;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 10px #ddd;
    }
  }
}

.sys-item {
  position: relative;
  width: 132px;
  height: 96px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  border: 1px solid rgba(235, 238, 245, 1);
  text-align: center;
  margin: 20px 20px 20px 0;
  padding: 0 20px;
  &:nth-child(8n) {
    margin-right: 0;
  }
  &:hover .sys-add {
    color: #999;
  }
  &:hover .el-icon-plus {
    color: #d9d9d9 !important;
  }
  .el-icon-error {
    position: absolute;
    z-index: 9999;
    right: -8px;
    top: -8px;
    font-size: 18px;
    color: red;
  }
  .icon-round {
    border-radius: 22px;
    margin: 20px auto 10px;
    line-height: 32px;
    text-align: center;
    color: #fff;
    width: 48px;
    height: 32px;
    border-radius: 8px;
    display: block;
  }
  .hollow-round {
    border-radius: 22px;
    margin: 20px auto 10px;
    line-height: 32px;
    text-align: center;
    color: #fff;
    width: 48px;
    height: 32px;
    border-radius: 8px;
    background-color: #f8f8f8;
    .el-icon-plus {
      color: rgba(217, 217, 217, 1);
    }
  }
  .sys-name {
    color: #555;
    text-align: center;
  }
  .sys-add {
    color: #ccc;
  }
}
.list-enter-active,
.list-leave-active {
  // transition: all 0.8s;
}
.list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  animation: bounce-in 0.6s;
}
@keyframes bounce-in {
  0% {
    transform: rotate(10deg);
  }
  10% {
    transform: rotate(-10deg);
  }
  20% {
    transform: rotate(10deg);
  }
  30% {
    transform: rotate(-10deg);
  }
  40% {
    transform: rotate(10deg);
  }
  50% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(10deg);
  }
  70% {
    transform: rotate(-10deg);
  }
  80% {
    transform: rotate(10deg);
  }
  90% {
    transform: rotate(-10deg);
  }
  100% {
    transform: rotate(10deg);
  }
}
</style>
